import { render, staticRenderFns } from "./PressHub.vue?vue&type=template&id=54bcacb5&"
import script from "./PressHub.vue?vue&type=script&lang=js&"
export * from "./PressHub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports